import React, { useCallback, useMemo, useRef } from 'react'
import styled from 'styled-components'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Dropdown from 'components/Luxkit/Dropdown/Dropdown'
import useToggle from 'hooks/useToggle'
import RadioGroup from 'components/Luxkit/RadioButton/RadioGroup'
import RadioButtonInput from 'components/Luxkit/RadioButton/RadioButtonInput'
import AssistChip from 'components/Luxkit/Chips/AssistChip'
import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'

const RelativeContainer = styled.div`
  position: relative;
`

export const CruiseSearchSortOptions = [
  {
    value: 'recommended',
    label: 'Recommended',
  },
  {
    label: 'Price (Lowest)',
    value: 'price.asc',
  },
  {
    label: 'Price (Highest)',
    value: 'price.desc',
  },
  {
    label: 'Depart soon',
    value: 'departure_date.asc',
  },
  {
    label: 'Newest',
    value: 'updated_at.desc',
  },
]

interface Props {
  sort: string;
  onChange: (newSort: App.OfferListSortByOptions) => void;
}

function CruiseSortDropdown(props: Props) {
  const { onChange, sort } = props

  const [open, toggleSortOpen, _, closeSort] = useToggle()
  const triggerRef = useRef<HTMLButtonElement>()

  const onSortChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.currentTarget.value as App.OfferListSortByOptions)
    closeSort()
  }, [closeSort, onChange])

  const selectedLabel = useMemo(() => {
    return CruiseSearchSortOptions.find(option => option.value === sort)?.label ?? 'Recommended'
  }, [sort])

  return <RelativeContainer>
    <AssistChip
      variant="filled"
      size="medium"
      onClick={toggleSortOpen}
      endIcon={<DropdownChevron open={open}/>}
      ref={triggerRef}
    >
      Sort: {selectedLabel}
    </AssistChip>
    <Dropdown
      triggerRef={triggerRef}
      open={open}
      onClose={closeSort}
    >
      <DropdownContainer fit="auto">
        <RadioGroup expanded>
          {CruiseSearchSortOptions.map(option => <RadioButtonInput
            value={option.value}
            onChange={onSortChange}
            key={option.label}
            checked={option.value ? option.value === sort : !sort}
            name="sort"
          >
            {option.label}
          </RadioButtonInput>)}
        </RadioGroup>
      </DropdownContainer>
    </Dropdown>
  </RelativeContainer>
}

export default React.memo(CruiseSortDropdown)
